import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/mac-os-classic/error.tsx");
